import {
  diffAddressLine,
  formatAddressLine1,
  formatAddressLine2,
  type AddressLike,
} from "@Light/utils/address";
import clsx from "clsx";
import { ReactNode } from "react";

export type AddressCardProps = {
  address: AddressLike;
  label?: ReactNode;
  /** Override the street line with custom text. */
  line1?: string | null;
  /** Bolds the parts of the street line that differ from this one. */
  diffAgainst?: string | null;
  className?: string;
  "data-testid"?: string;
};

export const AddressCard = ({
  address,
  label,
  line1,
  diffAgainst,
  className,
  ...props
}: AddressCardProps) => {
  const street = line1 ?? formatAddressLine1(address);

  return (
    <div
      className={clsx(
        "flex flex-col gap-1 rounded-xl bg-secondary p-4",
        className,
      )}
      {...props}
    >
      {label ? (
        <p className="text-sm text-tertiary leading-5">{label}</p>
      ) : null}
      <div className="text-md text-primary">
        <p className="leading-6">
          {!diffAgainst
            ? street
            : diffAddressLine(street, diffAgainst).map((segment, i) => (
                <span
                  key={i}
                  data-testid={segment.differs ? "address-diff" : undefined}
                  className={clsx(segment.differs && "font-semibold")}
                >
                  {segment.text}
                </span>
              ))}
        </p>
        <p className="leading-6">{formatAddressLine2(address)}</p>
      </div>
    </div>
  );
};
